import sliceCreator from '../../index.jsx';
import {GET_DEALER_BY_ID} from '../../../constants/index.jsx';
const _getDealerByIdAction = sliceCreator('GET_DEALER_BY_ID', GET_DEALER_BY_ID, 'get');

const { asyncAction: getDealerByIdAction, reducer, clearData: clearGetDealerByIdAction } = _getDealerByIdAction;

export default reducer;

export {
    getDealerByIdAction,
    clearGetDealerByIdAction
}